import * as React from 'react'
import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/it_management/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <ResponsivePage.Body>
        <Outlet />
      </ResponsivePage.Body>
    </CollectionsBootstrap>
  )
}

export default RootPage
